import { render, staticRenderFns } from "./RoleDelete.vue?vue&type=template&id=dc83a06a"
import script from "./RoleDelete.vue?vue&type=script&lang=js"
export * from "./RoleDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports